var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:none;}.b{stroke:#354d9e;stroke-linecap:round;stroke-linejoin:round;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-25 -659)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 13,
    height: 13,
    transform: "translate(25 659)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(27.167 660.625)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M12.667,18.25V17.167A2.167,2.167,0,0,0,10.5,15H6.167A2.167,2.167,0,0,0,4,17.167V18.25",
    transform: "translate(-4 -8.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 2.167,
    cy: 2.167,
    r: 2.167,
    transform: "translate(2.167)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.36b392e57972f9522ac58f4072d08480.svg";
export { ForwardRef as ReactComponent };